import { BaseModel } from "../base.model";
import { Synonyms } from "./synonym.model";

export type Definition = {
  id: string;
  definition: string;
  shortDefinition?: string;
  partOfSpeech: string;
  displayOrder: number;
  isVisible: boolean;
};

export type CompleteWord = {
  word: Word;
  synonyms: Synonyms;
};

export type Definitions = Definition[];
export type Words = Word[];

type WordProps = {
  id: string;
  word: string;
  root: string;
  definitions: Definitions;
  isVisible: boolean;
  hasBeenChecked: boolean;
  hasBeenReviewed: boolean;
  hasBeenPopulated: boolean;
  requiredFurtherReview?: boolean;
  isAutoSuggestCorrect?: boolean;
  level?: number;
  isSearchedByUser?: boolean;
};

export class Word extends BaseModel {
  id: string;
  word: string;
  root: string;
  definitions: Definitions;
  isVisible: boolean;
  hasBeenChecked: boolean;
  hasBeenReviewed: boolean;
  hasBeenPopulated: boolean;
  requiredFurtherReview?: boolean;
  isAutoSuggestCorrect?: boolean;
  level?: number;
  isSearchedByUser: boolean;

  constructor(data: WordProps) {
    super(data);
    this.id = data.word;
    this.word = data.word;
    this.root = data.root;
    this.definitions = data.definitions;
    this.isVisible = data.isVisible;
    this.hasBeenChecked = data.hasBeenChecked;
    this.hasBeenReviewed = data.hasBeenReviewed;
    this.hasBeenPopulated = data.hasBeenPopulated;
    this.requiredFurtherReview = data.requiredFurtherReview;
    this.isAutoSuggestCorrect = data.isAutoSuggestCorrect;
    this.level = data.level;
    this.isSearchedByUser = data.isSearchedByUser ?? false;
  }

  override get databaseConfig() {
    return {
      collection: "words",
      path: `/words/${this.id.toLowerCase()}`,
    };
  }

  static override fromMap(map: any) {
    return new Word(map);
  }
}
